module.exports = __webpack_public_path__ + "img/chevron_down_white.4a4ebf2e.svg";